import React from "react";

const Footer = () => {

    return (
        <div className="flex flex-col">
            <div class="flex w-full h-[150px] bg-transparency"></div>
            <div class="flex text-white text-xs font-bold justify-center pt-2 pb-4">&copy;2024 Goalkeepers Media. All rights reserved.</div>
        </div>
    )
};

export default Footer;
